/* ============================================================
   Coastal Editorial — global.js (vanilla, SK)
   ============================================================ */
(function () {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) =>
    (cents / 100).toLocaleString('sk-SK', { minimumFractionDigits: 2 }) +
    ' ' + (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '€');

  /* ---------- Cart drawer ---------- */
  const drawer = document.getElementById('CartDrawer');
  const cartBody = drawer ? drawer.querySelector('[data-cart-body]') : null;
  const FREE_SHIPPING_THRESHOLD = 5900; // 59,00 € v centoch

  let scrollLockY = 0;
  function lockBodyScroll() {
    scrollLockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollLockY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  function openCart() { if (drawer) { drawer.setAttribute('aria-hidden', 'false'); lockBodyScroll(); renderCart(); } }
  function closeCart() { if (drawer) { drawer.setAttribute('aria-hidden', 'true'); unlockBodyScroll(); } }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  async function getCart() { const r = await fetch('/cart.js'); return r.json(); }

  function updateCount(count) {
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'grid' : 'none';
    });
  }

  function shippingBarHtml(total) {
    const remaining = FREE_SHIPPING_THRESHOLD - total;
    const pct = Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100));
    if (remaining <= 0) {
      return `
        <div class="cart-shipping is-complete">
          <div class="cart-shipping__bar"><span style="width:100%"></span></div>
          <p class="cart-shipping__text">🎉 Máš dopravu zdarma</p>
        </div>`;
    }
    return `
      <div class="cart-shipping">
        <div class="cart-shipping__bar"><span style="width:${pct}%"></span></div>
        <p class="cart-shipping__text">Ešte <strong>${money(remaining)}</strong> do dopravy zdarma</p>
      </div>`;
  }

  function multibuyBarHtml(itemCount) {
    if (itemCount >= 2) {
      return '<div class="cart-multibuy is-active">🎉 Máš automaticky −10 % za kombináciu 2+ kusov</div>';
    }
    return '<div class="cart-multibuy">Pridaj ešte 1 kus a získaj <strong>−10 %</strong> automaticky</div>';
  }

  async function renderCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<p class="cart-empty">Načítavam…</p>';
    const cart = await getCart();
    updateCount(cart.item_count);
    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-empty">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>
          <p>Tvoja taška je zatiaľ prázdna.</p>
          <a href="/collections/all" class="btn btn--outline" data-cart-close>Pokračovať v nákupe</a>
        </div>`;
      return;
    }
    let html = shippingBarHtml(cart.total_price);
    html += multibuyBarHtml(cart.item_count);
    html += '<div class="cart-lines">';
    cart.items.forEach((item) => {
      html += `
        <div class="cart-line">
          <img class="cart-line__img" src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_180x$1') : ''}" alt="">
          <div class="cart-line__info">
            <div class="cart-line__title">${item.product_title}</div>
            ${item.variant_title ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
            <div class="cart-line__controls">
              <div class="cart-qty">
                <button data-qty="${item.key}" data-delta="-1" aria-label="Znížiť množstvo">−</button>
                <span>${item.quantity}</span>
                <button data-qty="${item.key}" data-delta="1" aria-label="Zvýšiť množstvo">+</button>
              </div>
              <button class="cart-line__remove" data-qty="${item.key}" data-delta="${-item.quantity}">Odstrániť</button>
            </div>
          </div>
          <div class="cart-line__price">${money(item.final_line_price)}</div>
        </div>`;
    });
    html += '</div>';
    html += `
      <div class="cart-foot">
        <div class="cart-foot__row"><span>Medzisúčet</span><strong>${money(cart.total_price)}</strong></div>
        <a href="/checkout" class="btn btn--block">K pokladni</a>
        <a href="/cart" class="cart-foot__link">Zobraziť celú tašku</a>
      </div>`;
    cartBody.innerHTML = html;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const cart = await getCart();
    const line = cart.items.find((i) => i.key === btn.dataset.qty);
    if (!line) return;
    const newQty = Math.max(0, line.quantity + parseInt(btn.dataset.delta, 10));
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.qty, quantity: newQty }),
    });
    renderCart();
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const original = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Pridávam…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      openCart();
    } catch (err) {
      console.error(err);
      if (submitBtn) submitBtn.textContent = 'Chyba — skús znova';
    } finally {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original; }
    }
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = JSON.parse(form.querySelector('[data-variant-json]').textContent);
    const idInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-price]');
    const submit = form.querySelector('[type="submit"]');
    function selected() {
      return Array.from(form.querySelectorAll('.variant-options input:checked')).map((i) => i.value);
    }
    function update() {
      const picks = selected();
      const match = data.variants.find((v) => v.options.every((opt, i) => opt === picks[i]));
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? 'Pridať do tašky' : 'Vypredané'; }
      }
    }
    form.querySelectorAll('.variant-options input').forEach((i) => i.addEventListener('change', update));
    update();
  });

  /* ---------- Scroll reveal ---------- */
  if (!reduce) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Parallax (subtle, scroll-driven) ---------- */
  const parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
  if (parallaxEls.length && !reduce) {
    let ticking = false;
    function frame() {
      const vh = window.innerHeight;
      parallaxEls.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const speed = parseFloat(el.dataset.parallax) || 0.12;
        const offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0) scale(1.14)`;
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }

 /* ---------- Horizontal slider: len šípky (vlastné ťahanie myšou odstránené — spôsobovalo nefunkčné kliky) ---------- */
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    if (!track) return;
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    const step = () => { const card = track.querySelector('.card, .slider-item'); return card ? card.offsetWidth + 24 : 320; };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() * 1.5, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step() * 1.5, behavior: 'smooth' }));
  });

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('.nav-toggle')) {
      const nav = document.querySelector('.site-header__nav');
      if (nav) nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
    }
  });

  getCart().then((c) => updateCount(c.item_count)).catch(() => {});
})();

/* ============================================================
   Gallery · Hotspots · Video  (separate IIFE)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Product gallery: thumbs + zoom ---------- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const mains = gallery.querySelectorAll('.product__main');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    function show(i) {
      mains.forEach((m) => m.classList.toggle('is-active', +m.dataset.index === i));
      thumbs.forEach((t) => t.classList.toggle('is-active', +t.dataset.thumb === i));
    }
    thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.thumb)));
  });

  /* ---------- Zoom lightbox ---------- */
  const box = document.querySelector('[data-zoom-box]');
  const boxImg = box ? box.querySelector('[data-zoom-img]') : null;
  function openZoom(src) { if (box && boxImg) { boxImg.src = src; box.setAttribute('aria-hidden', 'false'); } }
  function closeZoom() { if (box) box.setAttribute('aria-hidden', 'true'); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-zoom-open]') || e.target.classList.contains('product__main')) {
      const active = document.querySelector('.product__main.is-active');
      if (active) openZoom(active.dataset.zoom || active.src);
    }
    if (e.target.closest('[data-zoom-close]') || e.target === box) closeZoom();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeZoom(); });

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-hotspot]');
    document.querySelectorAll('.hotspot.is-open').forEach((h) => {
      if (!dot || h !== dot.closest('.hotspot')) h.classList.remove('is-open');
    });
    if (dot) { e.preventDefault(); dot.closest('.hotspot').classList.toggle('is-open'); }
  });

  /* ---------- Force-play muted autoplay videos ---------- */
  document.querySelectorAll('video[autoplay]').forEach((v) => {
    v.muted = true; v.setAttribute('playsinline', '');
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  });
})();
/* Quick-add from product cards */
(function () {
  'use strict';
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('.card__size[data-variant]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var prev = b.textContent;
    b.disabled = true;
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: b.dataset.variant, quantity: 1 }] })
      });
      if (!r.ok) throw new Error('add failed');
      var opener = document.querySelector('[data-cart-open]');
      if (opener) opener.click();
    } catch (err) {
      console.error(err); b.textContent = '✕';
      setTimeout(function () { b.textContent = prev; }, 1200);
    } finally {
      b.disabled = false;
    }
  });
})();
/* Editorial slider: arrows + counter */
(function () {
  'use strict';
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  document.querySelectorAll('.section-head--editorial').forEach(function (head) {
    var section = head.closest('section');
    if (!section) return;
    var track = section.querySelector('[data-slider-track]');
    if (!track) return;
    var prev = head.querySelector('[data-slider-prev]');
    var next = head.querySelector('[data-slider-next]');
    var cur = head.querySelector('[data-slider-current]');
    var stepW = function () { var c = track.querySelector('.slider-item, .card'); return c ? c.offsetWidth + 24 : 320; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepW() * 1.5, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepW() * 1.5, behavior: 'smooth' }); });
    if (cur) {
      var update = function () {
        var c = track.querySelector('.slider-item'); if (!c) return;
        var w = c.offsetWidth + 24;
        var total = track.querySelectorAll('.slider-item').length;
        var idx = Math.round(track.scrollLeft / w) + 1;
        cur.textContent = pad(Math.min(Math.max(idx, 1), total));
      };
      track.addEventListener('scroll', update, { passive: true });
      update();
    }
  });
})();
/* Sticky mobile Add to Cart */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var form = document.querySelector('[data-product-form]');
  var mainBtn = form ? form.querySelector('[type="submit"]') : null;
  var stickyBtn = bar.querySelector('[data-sticky-atc-submit]');
  if (!mainBtn || !stickyBtn) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    });
  }, { threshold: 0 });
  io.observe(mainBtn);

  stickyBtn.addEventListener('click', function () { mainBtn.click(); });

  var syncBtn = function () {
    stickyBtn.disabled = mainBtn.disabled;
    stickyBtn.textContent = mainBtn.textContent;
  };
  syncBtn();
  new MutationObserver(syncBtn).observe(mainBtn, { attributes: true, childList: true, characterData: true, subtree: true });
})();
/* Collection filters: mobile drawer + instant sort */
(function () {
  'use strict';
  var toggle = document.querySelector('[data-filter-toggle]');
  var panel = document.querySelector('[data-filter-panel]');
  if (toggle && panel) {
    panel.querySelectorAll('[data-filter-close]').forEach(function (el) {
      el.addEventListener('click', function () { panel.classList.remove('is-open'); });
    });
    toggle.addEventListener('click', function () { panel.classList.add('is-open'); });
  }
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var form = document.getElementById('CollectionFilterForm');
      if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  }
})();
/* Photo slideshow: fotky sa jemne prelínajú namiesto videa */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-slideshow]').forEach(function (box) {
    var slides = box.querySelectorAll('.photo-slideshow__slide');
    if (slides.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4500);
  });
})();